import React, { FC } from 'react';
import { HeadFC, PageProps, graphql } from 'gatsby';
import Layout from '../../components/Layout';
import View from '../../views/Wallet';
import SEO from '../../components/Head';

import { PageContext } from '../../../gatsby-node';

const Page: FC<PageProps<null, PageContext>> = ({ data }) => {
  console.log(data);
  return (
    <Layout>
      <View />
    </Layout>
  );
};

export const Head: HeadFC<Queries.HomePageQuery, PageContext> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <>
      <SEO
        meta={file?.childJson?.meta || null}
        pathname={location.pathname}
        locale={pageContext.locale}
      />
      <meta name="robots" content="noindex, nofollow" />
    </>
  );
};

export const query = graphql`
  query WalletPage {
    file(name: { eq: "content.en" }, relativePath: { glob: "**/home/**" }) {
      childJson {
        ...Meta
      }
    }
  }
`;

export default Page;
